import { getReadableAttributeName } from 'domain/experiment/attribute';

import { MAGIC_AUTO_COLUMN_WIDTH } from '../leaderboard-column-model';

import { BaseColumn, ColumnIdentifier, FloatColumn, FloatSeriesColumn } from './column-model';

export function isFloatColumn(col: BaseColumn): col is FloatColumn {
  return col.columnType === 'float';
}

export function isFloatSeriesColumn(col: ColumnIdentifier): col is FloatSeriesColumn {
  return isFloatSeriesColumnIdentifier(col);
}

export function isFloatSeriesColumnIdentifier(col: ColumnIdentifier): boolean {
  return col.columnType === 'floatSeries';
}

export function columnIdentityComparator(col1: ColumnIdentifier, col2: ColumnIdentifier): boolean {
  return (
    col1.id === col2.id &&
    col1.columnType === col2.columnType &&
    col1.aggregationMode === col2.aggregationMode
  );
}

export function serializeColumnIdentifier(colId: ColumnIdentifier): string {
  return `${colId.id}-${colId.columnType}-${colId.aggregationMode}`;
}

export function getColumnName(
  col: Pick<BaseColumn, 'id' | 'attributeName' | 'displayName'>,
): string {
  return col.displayName || getReadableColumnName(col.attributeName || col.id);
}

export function getColumnNameWithAggregation(
  col: Pick<BaseColumn, 'id' | 'attributeName' | 'displayName' | 'aggregationMode'>,
): string {
  const baseName = getColumnName(col);
  const aggregationName = col.aggregationMode ? ` (${col.aggregationMode})` : '';
  return `${baseName}${aggregationName}`;
}

export function getReadableColumnName(columnName: string): string {
  return getReadableAttributeName(columnName);
}

export function getReadableColumnIdentifier({ id, aggregationMode }: ColumnIdentifier): string {
  let identifier = id;

  if (aggregationMode && aggregationMode !== 'auto') {
    identifier = `${identifier} | ${aggregationMode.toUpperCase()}`;
  }

  return identifier;
}

export function computePinnedColumnsWidth(columns: BaseColumn[], ignoreAuto = false) {
  return columns.reduce((result: number, current) => {
    if (current.pinned) {
      if (current.autoWidthEnabled) {
        return result + (ignoreAuto ? MAGIC_AUTO_COLUMN_WIDTH : current.width);
      }

      return result + current.width;
    }

    return result;
  }, 0);
}
